<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="$router.back()">
            <ion-icon :icon="chevronBackSharp"></ion-icon> Retour
          </ion-button>
        </ion-buttons>
        <ion-title>{{metier.nom}}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <ion-card>
        <div class="img-container">
          <img v-if="metier.img" :src="imgUrl()"/>
          <div class="pastille-container">
            <div
                class="pastille"
                v-for="ilot in metier.ilots"
                :key="ilot.id"
                :style="{ backgroundColor: getCouleur(ilot.secteur_id, metier.secteurs) }"
            >
              <a>
                <div>
                  {{ ilot.numero }}
                </div>
              </a>
            </div>
          </div>
        </div>
        <ion-card-header>
          <ion-card-title>
            {{ metier.nom }}
          </ion-card-title>
        </ion-card-header>
        <ion-item
            color="dark"
            button
            lines="none"
            @click="toggleFav"
        >
          <ion-icon v-if="estFavoris"
                    :icon="starSharp"
                    slot="start"
                    color="primary"
          ></ion-icon>
          <ion-icon v-else
                    :icon="starOutline"
                    slot="start"
                    color="primary"
          ></ion-icon>
          <ion-label v-if="estFavoris">
            Retirer des favoris
          </ion-label>
          <ion-label v-else>
            Ajouter aux favoris
          </ion-label>
        </ion-item>

        <ion-item
            color="dark"
            button
            lines="none"
            @click="goToCarteMetier(id)"
        >
          <ion-icon :icon="navigate" slot="start"></ion-icon>
          <ion-label>Emplacement du stand</ion-label>
        </ion-item>

        <ion-card-content v-if="metier.description">
          {{metier.description}}
        </ion-card-content>

        <ion-item
            v-if="metier.lien"
            color="primary"
            lines="none"
            button
            :href="metier.lien"
        >
          <ion-icon :icon="linkOutline" slot="start"></ion-icon>
          <ion-label>Plus d'infos sur orientation.ch</ion-label>
        </ion-item>
      </ion-card>

      <MetierQualites v-if="metier.qualites.length > 0" :metier="metier" />
      <MetierFormations v-if="metier.duree" :metier="metier" />
      <!--
        <MetierTitre v-if="metier.titre" :metier="metier" />
      -->

      <created-by />
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonPage,
  IonCard,
  IonCardTitle,
  IonCardHeader,
  IonCardContent,
  IonItem,
  IonLabel,
  IonIcon,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonButton
} from "@ionic/vue";

import {
  chevronBackSharp,
  starSharp,
  starOutline,
  linkOutline,
  navigate
} from "ionicons/icons";

import MetierQualites from '@/components/MetierQualites';
import MetierFormations from '@/components/MetierFormations';
import CreatedBy from '@/components/CreatedBy';
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'PageDetailMetiers',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonCard,
    IonCardTitle,
    IonCardHeader,
    IonCardContent,
    IonItem,
    IonLabel,
    IonIcon,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonButton,
    CreatedBy,
    MetierQualites,
    MetierFormations
  },
  setup() {
    return { chevronBackSharp, starSharp, starOutline, linkOutline, navigate };
  },
  props: {
    id: {
      required: true
      // type: Number
    }
  },
  computed: {
    ...mapGetters(['getMetier', 'isFavori']),
    estFavoris () {
      return this.isFavori(this.id)
    },
    metier() {
      return this.getMetier(this.id)
    }
  },
  methods: {
    ...mapActions(['toggleFavori', 'setCarteMetier', 'setCarteIlot']),
    toggleFav () {
      this.toggleFavori(this.id)
    },
    goToCarteMetier(idMetier) {

      // S'il y a un seul ilot
      if (this.metier.ilots.length === 1) {
        // Affiche l'ilots et tous les métiers sur la carte
        this.setCarteIlot(this.metier.ilots[0].id)
      } else {
        // Sinon on affiche tous les emplacements du métiers
        this.setCarteMetier(idMetier)
      }

      this.$router.push({ name: 'carte' })
    },
    // Parcours les secteurs et retourne la couleur du secteur pour l'id en paramètre
    getCouleur(idSecteur, listeSecteurs) {
      const secteurTrouve = listeSecteurs.find((secteur) => secteur.id === idSecteur);
      if (secteurTrouve) {
        return secteurTrouve.couleur;
      } else {
        // Sinon retourne un noir
        return 'black';
      }
    },
    goBack () {
      // TODO améliorer navigation retourner aux écrans de base
      // ou réinitialiser la navigation sur certaines pages
      // this.$router.back()
      this.$router.back()
    },
    imgUrl () {
      return require('@/assets/metiers/' + this.metier.img)
    }
  }
}
</script>

<style lang="scss" scoped>
.img-container {
  position: relative;
  overflow: hidden;
  z-index: 1;

  .pastille-container {
    flex-wrap: wrap;
    z-index: 2;
    height: calc(100% - 3px);
    display: flex;
    align-items: start;
    justify-content: end;
    padding: 15px;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    width: 150px;
    top: 0;
    left: 0;

    a {
      text-underline: none;
      color: black;
    }

    .pastille {
      box-shadow: rgba(100, 100, 111, 0.22) 0px 7px 29px 0px;
      background: #ffffff;
      padding: 0 20px;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000000;
      font-weight: bold;
      font-size: 1.1rem;
      a {
        color:white;
      }
      .separator {
        margin: 0 10px;
        width: 2px;
        height: 20px;
        background: rgba(255,255,255,0.3);
      }
    }
  }
}

</style>
